import * as fetch from 'isomorphic-fetch';
import * as Promise from 'es6-promise';
import { ActionType, ActionTypes } from '../../actions/index';
import { IAppState } from '../../reducers/index';
import { ISeatInCartRequestModel, createFilterRequest } from '../../actions/fetch';
import { SeatingOptionGroup } from '../../classes/seating-option';
import { ISeatMatchRequestModel } from '../../classes/request-model';
import { IExchangeTicket } from '../../classes/ticket-exchange';
import { getSelectedTicketCount } from '../../helpers/price-type-helpers';

export interface IFetchStateAction {
    type: ActionType;
    value?: any;
}

function requestSeatMatches(requestModel: ISeatMatchRequestModel) {
    return {
        type: ActionTypes.REQUEST_SEATS,
        value: requestModel
    }
}

function receiveSeatMatches(result) {
    return {
        type: ActionTypes.RECEIVE_SEATS,
        value: result
    }
}

function setSeatMatchCount(count: number, isOnlyADASeats: boolean) {
    return {
        type: ActionTypes.SET_MATCHED_COUNT,
        value: { count: count, onlyADASeats: isOnlyADASeats }
    };
}

function updateSeatMatch(requestModel: ISeatMatchRequestModel, seatmapId: string) {
    return fetch(`${window.location.origin}/api/seating/GetSeatsAvailable`,
        {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            body: JSON.stringify({
                itemType: requestModel.itemType,
                itemId: requestModel.itemId,
                minPrice: requestModel.minPrice,
                maxPrice: requestModel.maxPrice,
                //quantity: requestModel.seatQuantity,
                allowSeparatedSeats: requestModel.allowSeparatedSeats,
                priceTypeQuantities: requestModel.requestedPriceTypes.filter(pt => { return pt.quantity > 0 }),
                venueLevels: requestModel.selectedVenueLevels,
                allowAisleAccessSelected: requestModel.allowAisleAccessSelected,
                additionalSeatingOptions: requestModel.additionalSeatingOptions,
                language: requestModel.language
            }),
            credentials: 'same-origin'
        })
        .then(response => {
            if (response.ok) {
                return response.json();
            } else {
                return "ERROR";
            }
        })
        .catch(error => {
            console.error(error);
        });
}

export function fetchSeatMatches() {
    return (dispatch, state) => {
        let currentState: IAppState = state();

        const seatMatchRequest = createFilterRequest(currentState);
        if (getSelectedTicketCount(currentState.priceTypesModel) > 0) {

            dispatch(requestSeatMatches(seatMatchRequest));
            updateSeatMatch(seatMatchRequest, '').then((response: any) => {
                if (response === "ERROR") {
                    dispatch(receiveSeatMatches(currentState.appSettingsModel.filterErrorToast));
                } else {
                    if (Number(response.seatsAvailable) == NaN) {
                        console.error('Seat match has returned a non-number value.');
                    }

                    dispatch(receiveSeatMatches(fetchToastText(response.seatsAvailable, currentState.appSettingsModel.filterToastThreshold, currentState.appSettingsModel.filterFoundToast)));
                    dispatch(setSeatMatchCount(response.seatsAvailable, response.onlyADASeats));
                }
            });
        }
    }
}

function fetchToastText(response, filterThreshold, filterFoundToast) {
    if ((filterThreshold == '' || Number(response) != NaN) && (Number(response) <= Number(filterThreshold)))
        return response + ' ' + filterFoundToast;
    return filterThreshold + '+ ' + filterFoundToast;
}
